<template>
  <div v-if="showTips" class="tips">
    {{ tips }}
  </div>
  <div class="box">
    <div v-if="carList.length" class="carListBox">
      <div class="fvlr carBox" v-for="item in carList" :key="item.id">
        <div class="fhl content" @click="selectCar(item)">
          <div class="fvl">
            <div class="flag" v-show="item.defaultFlag">默认</div>
            <!-- <div class="carName">{{ item.nickName }}</div> -->
            <img class="flagImg" v-show="item.statusFlag === 2" src="../../../assets/images/flag.png" />
          </div>
          <div class="mark">{{ item.plate || '暂无车牌号' }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ item.model }}</div>
          <div class="vin">VIN: {{ item.vin }}</div>
        </div>
        <img class="edit" @click="editCarInfoFn(item)" src="../../../assets/images/edit.png" />
      </div>
    </div>
    <div class="btnContainer">
      <van-button @click="addCar" type="primary" block>新增车辆</van-button>
      <van-button v-if="showTips" @click="addIntention" type="warning" block class="warning">暂不选择车辆</van-button>
    </div>
    <Loading v-if="isShowLoad" />
  </div>
</template>

<script>
import { getPlanDetail } from '@/api/plan'
import { Dialog , Toast} from 'vant'
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { myCarList } from '@/api/car'
import { getcheckTyrePackageUse } from '@/api/tyre'
import Loading from '@/components/common/Loading.vue'
import moment from 'moment'
export default {
  components: {
    Loading
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const state = reactive({
      carList: [],
      currentTime: '',
      isShowLoad: true,
      tips: '',
      payTypeFlag: ''
    })
    const addCar = () => {
      router.push({
        path: '/editCarInfo',
        query: {
          isCreate: true,
          event: '新增车辆'
        }
      })
    }
    //新增意向金
    //setCurrentCarInfo 新增属性intention:true用于后面意向金的判断 与 id默认为-1
    const addIntention = () => {
      Dialog.alert({
        message: '选择暂不选择车辆，支付致友计划意向金后，预约经销商进店完成车型资质审核等后续流程。',
        confirmButtonText: '确定'
      }).then(() => {
        let { callBack } = route.query
        if (callBack !== 'true') return
        store.dispatch('setCurrentCarInfo', {
          id: -1,
          intention: true
        })
        router.go(-1)
      })
    }

    const editCarInfoFn = item => {
      store.dispatch('setCurrentCarInfo', item)
      router.push({
        path: '/editCarInfo',
        query: {
          isCreate: false,
          event: '修改车辆',
          currentTime: moment(state.currentTime).format('YYYY-MM-DD')
        }
      })
    }
    const selectCar =async(item) => {
       let {currentGoodsInfo,currentCarInfo,brandInfo} =store.state
      let {loyaltyId}= route.query
      if(currentGoodsInfo?.priceTypeFlag==3 && currentGoodsInfo?.loyaltyTypeFlag==2 && currentCarInfo?.id){
          let params={customerCarId:item.id, loyaltyId,brand:brandInfo?.brand || '',spec:brandInfo?.spec || '',productNo:brandInfo?.productNo || ''}
          let res= await getcheckTyrePackageUse(params)
          if(res.errorMsg){
            Toast(res.errorMsg)
            return false
          }

      }
      let { callBack } = route.query
      if (callBack !== 'true') return
      store.dispatch('setCurrentCarInfo', item)
      router.go(-1)
    }
    const refreshCurrentCarInfo = list => {
      let { currentCarInfo } = store.state
      let listCurrent = list.find(item => item.id === currentCarInfo.id)
      listCurrent && store.dispatch('setCurrentCarInfo', listCurrent)
    }
    // 获取致友计划详情信息
    const getPlanDetailFn = async params => {
      if (!params.loyaltyId) return
      let data = await getPlanDetail(params)
      state.payTypeFlag = data.payTypeFlag
    }
    //付款方式{1:定金 2:全款 4:意向金 6：全款意向金}名称
    const showTips = computed(() => [4, 6].includes(state.payTypeFlag))
    onMounted(async () => {
       let { currentCarInfo, currentGoodsInfo } = store.state
      const loyaltyId = route.query.loyaltyId
      const qrcodeHistoryId = route.query.qrcodeHistoryId
      if (loyaltyId) {
        await getPlanDetailFn({ customerCarId: currentCarInfo?.id, loyaltyId, qrcodeHistoryId: qrcodeHistoryId || '', type: currentGoodsInfo?.type ? 2 : null })
      }
      let { list, currentTime } = await myCarList()
      state.carList = list
      if (list.length == 0) {
        state.tips = '可选择“暂不选择车辆”并支付意向金'
      }
      if (list.length == 1) {
        state.tips = '可选择车辆进行购买，或选择“暂不选择车辆”并支付意向金'
      }
      if (list.length > 1) {
        state.tips = '可选择一辆车进行购买，或选择“暂不选择车辆”并支付意向金'
      }
      state.currentTime = currentTime
      state.isShowLoad = false
      store.dispatch('setMyCarList', list)
      refreshCurrentCarInfo(list)
    })
    return {
      ...toRefs(state),
      showTips,
      addCar,
      addIntention,
      editCarInfoFn,
      selectCar
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.van-dialog__button) {
  &:first-child {
    .van-button {
      color: #666666 !important;
    }
  }
  &:last-child {
    .van-button {
      color: #0066ff !important;
    }
  }
}
.flag {
  font-size: 12px;
  transform: scale(0.75);
  background: #3088c5;
  padding: 2px 4px;
  color: #ffffff;
  border-radius: 4px;
  line-height: 1.4;
}
.mark {
  padding: 8px 0;
  color: #666666;
  text-align: left;
}
.tips {
  // position: fixed;
  // top: 80px;
  // left: 0;
  width: 100%;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  background: #4aa2fa;
  color: #fff;
}
.carBox {
  padding: 10px 20px;
  height: 100px;
  box-sizing: border-box;
  background: #ffffff;
  margin: 8px 0;
  font-size: 14px;
  .content {
    width: 100%;
  }
}
.edit {
  width: 20px;
  height: 20px;
  margin-left: 20px;
}
.carName {
  font-size: 16px;
}
.vin {
  color: #999999;
}
.flagImg {
  width: 22px;
  height: 15px;
}
.btnContainer {
  margin: 40px 20px;
  width: 335px;
  position: sticky;
  top: 80%;
  .warning {
    margin-top: 10px;
    background: #fa824e;
    color: #fff;
  }
}
.carListBox {
  padding: 8px 0;
  box-sizing: border-box;
}
</style>
